function refreshProgressBar() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      const total = cart.total_price / 100;
      const goal = 100; // Set your target amount here (e.g., $100)
      const progress = Math.min((total / goal) * 100, 100);

      // Replace these quotes with the actual class names from your UI
      const barFill = document.querySelector('.progress-bar-fill'); 
      const message = document.querySelector('.progress-message');

      if (barFill) barFill.style.width = progress + '%';
      if (message) {
        const diff = (goal - total).toFixed(2);
        message.innerHTML = diff > 0 
          ? `Add <b>$${diff}</b> more to unlock your discount!` 
          : `🎉 Discount Applied!`;
      }
    });
}

// This "Observer" watches for any changes to the cart drawer/page
const observer = new MutationObserver(() => refreshProgressBar());
const cartContainer = document.querySelector('cart-drawer, #cart-notification, .cart-items');
if (cartContainer) observer.observe(cartContainer, { subtree: true, childList: true });

// Initial load
document.addEventListener('DOMContentLoaded', refreshProgressBar);